import { Injectable } from '@nestjs/common';
import { ProductionInventory } from '../entities/production-inventory.entity';
import { RawMaterial } from '../entities/raw-material.entity';
import { ProdInvDTO } from './prod-inv.dto';
import { ProductionInventoryData } from './production-inventory.dto';


@Injectable()
export class ProdInvAdapter {
  

  public convertDtoToEntity(  grnDto: ProdInvDTO,  isUpdate: boolean = false ): ProductionInventory {
    const grn = new ProductionInventory();
    grn.productionInventoryId=grnDto.productionInventoryId;
    // grn.grnNumber = grnDto.grnNumber;
    grn.lotNumber = grnDto.lotNumber;
    grn.subLotNumber = grnDto.lotNumber;
    grn.saleOrderId=grnDto.saleOrderId;
    grn.saleOrderItemId=grnDto.saleOrderItemId;
    grn.operation=grnDto.operation;
    grn.nextOperation=grnDto.nextOperation;
    grn.physicalQuantity=grnDto.physicalQuantity;
    grn.inputGrade=String(grnDto.inputGrade);
    grn.plantId = grnDto.plantId;
    grn.subPlantId = grnDto.subPlantId;
    grn.boxes=grnDto.boxes;
    grn.weighmentReq = grnDto.weighmentReq;
    grn.status = grnDto.status;
    grn.createdUser = grnDto.createdUser;
    

   // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    // grn.isActive=grnDto.isActive==undefined?true:grnDto.isActive;
    // if (isUpdate) {
    //     grn.updatedUser = grnDto.updatedUser;
    // } else {
    //     grn.isActive = true;
    //     grn.createdUser = grnDto.createdUser;
    //     grn.grnNumber=grnDto.grnNumber;
    //     grn.lotNumber=grnDto.lotNumber;
    // }
   return grn;
  }
  public convertEntityToDto(grnObject: ProductionInventory): ProdInvDTO {
    const grnDto= new ProdInvDTO;
    grnDto.productionInventoryId=grnObject.productionInventoryId;
    // grnDto.grnNumber=grnObject.grnNumber;
    grnDto.lotNumber=grnObject.lotNumber;
    grnDto.saleOrderId=grnObject.saleOrderId;
    grnDto.saleOrderItemId=grnObject.saleOrderItemId;
    grnDto.operation=grnObject.operation;
    grnDto.nextOperation=grnObject.nextOperation;
    grnDto.physicalQuantity=grnObject.physicalQuantity;
    grnDto.inputGrade=Number(grnObject.inputGrade);
    grnDto.boxes=grnObject.boxes;
    grnDto.plantId=grnObject.plantId;
    grnDto.subPlantId=grnObject.subPlantId;
    grnDto.weighmentReq = grnObject.weighmentReq;
    grnDto.status=grnObject.status;
    // grnDto.isActive = grnObject.isActive;
    grnDto.createdAt = grnObject.createdAt;
    grnDto.updatedAt = grnObject.updatedAt;
    grnDto.createdUser = grnObject.createdUser;
    grnDto.updatedUser = grnObject.updatedUser;
    grnDto.versionFlag = grnObject.versionFlag;
    return grnDto;
  }

  convertBeHeadingDtoToEntity(req:ProductionInventoryData){
    const beHeading = new RawMaterial();
    beHeading.prodInvId=req.productionInventoryId;
    beHeading.saleOrderId=req.saleOrderId;
    beHeading.saleOrderItemId=req.saleOrderItemId;
    // beHeading.quantity=req.availableQuantity;
    // beHeading.count=req.count;
    beHeading.boxes=req.boxes;
    // beHeading.plantId = req.plantId;
    beHeading.subPlantId = req.subPlantId;
    beHeading.workStation = req.workstation;
    beHeading.workStationType = req.workStationType;
    if (req.productionInventoryId) {
        beHeading.updatedUser = req.updatedUser;
    } else {
        beHeading.createdUser = req.createdUser;
        beHeading.lotNumber=req.lotNumber;
    }
   return beHeading;
  }
}
